const YOTPO_STORE_ID = "hEc3IC0lCXuQ15phwUS54IFWUkW2L7LAcNLTHkt6";

if (!customElements.get('yotpo-rating-star')) {
    class YotpoRatingStar extends HTMLElement {
        constructor() {
            super();
            this.productId = this.getAttribute('data-product-id');
            this.reviewContainer = this.querySelector('[data-rating-container]');
            this.alwaysDisplay = this.getAttribute('always-display');
        }

        async connectedCallback() {
            this.domain = window.location.hostname;
            this.yotpoLanguage = this.domain.includes('qc.emma-sleep.ca') ? 'avis' : 'reviews';
            this.yotpoCustomerLanguage = this.domain.includes('qc.emma-sleep.ca') ? 'de clients vérifiés' : 'from verified customers';


            if (!this.productId || !YOTPO_STORE_ID || !this.reviewContainer) return;

            const fetchReview = async () => {
                const url = `https://api-cdn.yotpo.com/v3/storefront/store/${YOTPO_STORE_ID}/product/${this.productId}/ratings`;
                try {
                    const res = await fetch(url);
                    if (!res.ok) return null;
                    return await res.json();
                } catch (e) {
                    console.error("Yotpo fetch error for product", e);
                    return null;
                }
            };

            const reviewsList = await fetchReview();
            if (!reviewsList || !reviewsList.bottomline || reviewsList.bottomline.totalReviews == 0) {
                if (this.alwaysDisplay === "true") {
                    this.style.visibility = "hidden";
                } else {
                    this.style.display = 'none';
                    return;
                }
            }

            this.reviewContainer.innerHTML =  `
        <span class="flex items-center gap-1"> 
      ${Array(5).fill().map((_, i) => `
        <svg class="w-[14px] h-[14px] md:w-4 md:h-4 text-[var(--color-critical-600)] star-rating" xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
        <path d="M12.9996 4.18261C13.5842 4.18261 14.0809 4.54036 14.2652 5.09407C14.4488 5.64616 14.2658 6.22851 13.799 6.57714L11.0705 8.6149L11.9742 11.9892C12.1265 12.5596 11.9032 13.1338 11.4058 13.4521C10.9058 13.7725 10.2893 13.7327 9.83289 13.3551L7.38107 11.32C7.25737 11.2171 7.07736 11.2171 6.95301 11.32L4.50217 13.3551C4.25184 13.5628 3.95334 13.6676 3.65223 13.6676C3.40386 13.6676 3.15419 13.5967 2.92827 13.4515C2.4312 13.1331 2.20855 12.5589 2.36121 11.9892L3.26421 8.6149L0.53634 6.57747C0.0695462 6.22786 -0.1134 5.64583 0.0705195 5.09342C0.25444 4.54003 0.751186 4.18261 1.33549 4.18261H4.49695C4.63791 4.18261 4.76421 4.09407 4.81141 3.96257L5.91199 0.88314C6.1034 0.34668 6.59624 0 7.16753 0C7.73849 0 8.23133 0.34668 8.42273 0.88346L9.52429 3.96289C9.57117 4.0944 9.69747 4.18261 9.83809 4.18261H12.9996Z" fill="currentColor"/>
        </svg>`).join("")}
        <p class="score-rating leading-[18px] text-[var(--color-neutral-900)] text-xs font-semibold">${Number(reviewsList.bottomline.averageScore.toFixed(1))}</p>
        <p class="text-[var(--color-neutral-900)] leading-[18px] text-xs font-normal">(${reviewsList.bottomline.totalReviews} ${this.yotpoLanguage})</p>
        </span>
        <div class="flex items-center gap-1">
        <svg class=" verify-customer hidden text-[var(--color-neutral-900)] w-[10px] h-[10px]" xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
          <path d="M8.69148 4.87475L9.25447 3.87134C9.33992 3.71777 9.35749 3.53369 9.30281 3.36645C9.24861 3.19994 9.12556 3.06249 8.96687 2.98974L7.92292 2.50879L7.78865 1.36792C7.76814 1.19336 7.67488 1.03393 7.53279 0.930905C7.39021 0.82739 7.20906 0.787595 7.03767 0.822505L5.91071 1.04712L5.13093 0.20288C5.01179 0.07422 4.84333 0 4.66755 0C4.49225 0 4.32282 0.073485 4.20246 0.20288L3.42341 1.04688L2.29646 0.82251C2.12312 0.787355 1.94343 0.82715 1.80183 0.930665C1.65974 1.03369 1.56623 1.19287 1.54548 1.36792L1.41096 2.50903L0.367746 2.9895C0.207831 3.06298 0.0850312 3.20093 0.0308312 3.36817C-0.0236138 3.53565 -0.00530379 3.71948 0.0806362 3.87256L0.642646 4.87475L0.0808762 5.87671C-0.00506382 6.02954 -0.0233738 6.21313 0.0305812 6.38013C0.0845362 6.54712 0.207096 6.68531 0.367496 6.76002L1.41095 7.24049L1.54547 8.38258C1.56647 8.55689 1.65997 8.71607 1.80231 8.8191C1.94415 8.92213 2.12335 8.96119 2.29645 8.92701L3.4234 8.70289L4.20343 9.54762C4.32282 9.67603 4.49177 9.74975 4.66706 9.74975C4.84284 9.74926 5.01179 9.67554 5.13093 9.54663L5.91023 8.70288L7.03767 8.927C7.20905 8.96167 7.39069 8.92211 7.5323 8.8186C7.67439 8.71557 7.76765 8.55639 7.78865 8.38159L7.92292 7.24047L8.96736 6.75952C9.12654 6.68579 9.2491 6.54809 9.3033 6.38159C9.3575 6.21509 9.33992 6.03149 9.25398 5.8767L8.69148 4.87475ZM8.00495 5.18384L8.53718 6.13207L7.55085 6.58617C7.35212 6.67651 7.21198 6.86792 7.18561 7.08667L7.05866 8.16675L5.99274 7.95434C5.77692 7.9104 5.55182 7.98413 5.40485 8.14477L4.66681 8.9436L3.93024 8.14624C3.81061 8.01538 3.63972 7.94214 3.46467 7.94214C3.42365 7.94214 3.38264 7.94604 3.34186 7.95434L2.27521 8.16675L2.14802 7.08667C2.12238 6.86889 1.98298 6.67748 1.78498 6.58666L0.797431 6.13207L1.3299 5.18237C1.43708 4.98998 1.43708 4.75977 1.32941 4.56592L0.797431 3.61743L1.78352 3.16308C1.98274 3.07251 2.12238 2.88086 2.14802 2.66284L2.27522 1.58301L3.34138 1.79541C3.55695 1.83813 3.78107 1.76513 3.92927 1.60473L4.66682 0.80566L5.40485 1.60498C5.55378 1.76562 5.77936 1.83935 5.99225 1.79541L7.05866 1.58301L7.1861 2.66382C7.21246 2.88208 7.3526 3.07348 7.54938 3.16235L8.53717 3.61743L8.00543 4.56543C7.89607 4.75903 7.89607 4.99048 8.00495 5.18384Z" fill="#58524E"/>
          <path d="M6.15193 3.60962L4.41706 5.34448L3.6822 4.60962C3.53571 4.46313 3.29841 4.46313 3.15192 4.60962C3.00544 4.7561 3.00544 4.9934 3.15192 5.13989L4.15192 6.13989C4.22517 6.21313 4.32112 6.24975 4.41706 6.24975C4.51301 6.24975 4.60896 6.21313 4.6822 6.13989L6.6822 4.13989C6.82868 3.9934 6.82868 3.7561 6.6822 3.60962C6.53571 3.46313 6.29841 3.46314 6.15193 3.60962Z" fill="#58524E"/>
        </svg>
        <p class="verify-customer hidden text-[var(--color-neutral-900)] text-xs font-normal">${this.yotpoCustomerLanguage}</p>
        </div>
        ` ;
        }
    }

    customElements.define('yotpo-rating-star', YotpoRatingStar);
}

const cache = new Map();
if (!customElements.get('yotpo-review-carousel')) {
    class YotpoReviewCarousel extends HTMLElement {
        constructor() {
            super();
            this.reviewContainer = this.querySelector('[data-review-list]');
            this.type = this.getAttribute('type') || 'page';
        }

        async connectedCallback() {
            if (!this.reviewContainer) return;
            const productReviewData =
                window.productsData ||
                window.productDataCollection ||
                window.productData ||
                [];
            if (!productReviewData.length) {
                console.warn('Yotpo: No product data found for carousel');
                this.style.display = 'none';
                return;
            }

            let reviews = [];

            switch (this.type) {
                case 'page':
                    reviews = await this.fetchCollectionReviews(productReviewData);
                    break;
                case 'collection':
                    reviews = await this.fetchCollectionReviews(productReviewData);
                    break;
                case 'product':
                    reviews = await this.fetchProductReviews(productReviewData);
                    break;
                default:
                    console.warn(`Yotpo: Unknown carousel type "${this.type}"`);
                    return;
            }

            this.renderReviews(reviews);
            this.dispatchLoaded();
        }

        async fetchJSON(url) {
            if (cache.has(url)) return cache.get(url);
            try {
                const res = await fetch(url);
                if (!res.ok) throw new Error(`Failed: ${res.status}`);
                const data = await res.json();
                cache.set(url, data);
                return data;
            } catch (err) {
                console.error('Yotpo fetch error:', err);
                return null;
            }
        }

        // async fetchTopReviews(productReviewData) {
        //   const url = `https://api-cdn.yotpo.com/v3/storefront/store/${YOTPO_STORE_ID}/top_reviews?reviewType=product`;
        //   const data = await this.fetchJSON(url);
        //   if(!data?.reviews?.length) {
        //     this.style.display = 'none';
        //     return [];
        //     }

        //   return data.products.map(product => {
        //     const review = data.reviews.find(r => r.productId === product.id);
        //     if (!review) return null;
        //     return {
        //       title: review.title,
        //       content: review.content,
        //       score: review.score,
        //       displayName: review.user?.displayName || 'Anonymous',
        //       productName: product.name,
        //       productUrl: this.getProductUrl(productReviewData, product.domainKey),
        //     };
        //   }).filter(Boolean);
        // }

        async fetchCollectionReviews(productReviewData) {
            const MAX_PRODUCTS = 6;
            const limitedProducts = productReviewData.slice(0, MAX_PRODUCTS);
            const perPageNumber = productReviewData.length < 2 ? 8 : (productReviewData.length > 4 ? 2 : 3);

            const results = await Promise.all(limitedProducts.map(p =>
                this.fetchJSON(`https://api-cdn.yotpo.com/v3/storefront/store/${YOTPO_STORE_ID}/product/${p.id}/reviews?page=1&perPage=${perPageNumber}&sort=smart`)
            ));

            return results.flatMap(x => {
                if (!x?.products?.length) {
                    this.style.display = 'none';
                    return [];
                }
                if (!x?.reviews?.length) return [];

                const product = x.products[0];
                const productUrl = this.getProductUrl(productReviewData, product.domainKey);
                return x.reviews.map(r => ({
                    title: r.title,
                    content: r.content,
                    score: r.score,
                    displayName: r.user?.displayName || 'Anonymous',
                    productName: product.name,
                    productUrl,
                }));
            });
        }

        async fetchProductReviews(productReviewData) {
            const results = await Promise.all(productReviewData.map(p =>
                this.fetchJSON(`https://api-cdn.yotpo.com/v3/storefront/store/${YOTPO_STORE_ID}/product/${p.id}/reviews?page=1&perPage=10&sort=smart`)
            ));

            return results.flatMap(x => {
                if (!x?.products?.length) {
                    this.style.display = 'none';
                    return [];
                }
                const product = x.products[0];
                const productUrl = this.getProductUrl(productReviewData, product.domainKey);
                return x.reviews.map(r => ({
                    title: r.title,
                    content: r.content,
                    score: r.score,
                    displayName: r.user?.displayName || 'Anonymous',
                    productName: product.name,
                    productUrl,
                }));
            });
        }

        getProductUrl(productReviewData, id) {
            return productReviewData.find(p => p.id == id)?.url || '#';
        }

        renderStars(score) {
            return `
        <div class="flex gap-1 items-center">
          ${Array.from({length: 5}, (_, i) => `
            <svg class="w-4 h-4 ${i < score ? 'text-[var(--color-critical-600)]' : 'text-[var(--color-neutral-300)]'}" viewBox="0 0 15 14" fill="none">
              <path d="M12.9996 4.18261C13.5842 4.18261 14.0809 4.54036 14.2652 5.09407C14.4488 5.64616 14.2658 6.22851 13.799 6.57714L11.0705 8.6149L11.9742 11.9892C12.1265 12.5596 11.9032 13.1338 11.4058 13.4521C10.9058 13.7725 10.2893 13.7327 9.83289 13.3551L7.38107 11.32C7.25737 11.2171 7.07736 11.2171 6.95301 11.32L4.50217 13.3551C4.25184 13.5628 3.95334 13.6676 3.65223 13.6676C3.40386 13.6676 3.15419 13.5967 2.92827 13.4515C2.4312 13.1331 2.20855 12.5589 2.36121 11.9892L3.26421 8.6149L0.53634 6.57747C0.0695462 6.22786 -0.1134 5.64583 0.0705195 5.09342C0.25444 4.54003 0.751186 4.18261 1.33549 4.18261H4.49695L5.91199 0.88314C6.1034 0.34668 6.59624 0 7.16753 0C7.73849 0 8.23133 0.34668 8.42273 0.88346L9.52429 3.96289H12.9996Z" fill="currentColor"/>
            </svg>`).join('')}
          <div class="text-base font-semibold ml-1">${score}</div>
        </div>
      `;
        }

        renderReviewCard({title, content, score, displayName, productName, productUrl}) {
            return `
        <li class="splide__slide">
          <div class="flex flex-col items-center max-h-[260px] gap-8 w-[300px] text-center bg-[var(--color-neutral-50)] text-[var(--color-neutral-900)] font-normal px-3 py-4 rounded-lg">
            <div class="flex flex-col items-center">
              <div class="flex gap-1 mb-3">${this.renderStars(score)}</div>
              <p class="review-title text-md font-semibold line-clamp-1 mb-1">"${title}"</p>
              <p class="review-desc text-base font-normal line-clamp-3 mb-3 min-h-[72px] max-h-[72px]">${content}</p>
              <div class="flex items-center gap-1 text-[var(--color-neutral-800)]">
                <p class="text-sm font-semibold">${displayName}</p>
                <svg class="w-5 h-5 text-[var(--color-neutral-900)]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
                  <path d="M16.7075 10.0001L17.6458 8.32771C17.7882 8.07177 17.8175 7.76497 17.7264 7.48624C17.636 7.20873 17.4309 6.97965 17.1665 6.85839L15.4265 6.0568L15.2028 4.15535C15.1686 3.86441 15.0131 3.5987 14.7763 3.427C14.5387 3.25447 14.2368 3.18815 13.9511 3.24633L12.0729 3.62069L10.7732 2.21362C10.5747 1.99919 10.2939 1.87549 10.0009 1.87549C9.70877 1.87549 9.42638 1.99796 9.22578 2.21362L7.92736 3.62028L6.04911 3.24634C5.76021 3.18775 5.46072 3.25407 5.22472 3.4266C4.98791 3.59831 4.83207 3.86361 4.79747 4.15536L4.57327 6.0572L2.83459 6.85799C2.56806 6.98046 2.3634 7.21036 2.27306 7.4891C2.18232 7.76823 2.21284 8.07462 2.35607 8.32976L3.29276 10.0001L2.35647 11.67C2.21324 11.9247 2.18272 12.2307 2.27265 12.509C2.36257 12.7874 2.56684 13.0177 2.83417 13.1422L4.57327 13.943L4.79747 15.8464C4.83246 16.137 4.9883 16.4023 5.22552 16.574C5.46193 16.7457 5.7606 16.8108 6.04909 16.7538L7.92735 16.3803L9.2274 17.7882C9.42638 18.0022 9.70796 18.1251 10.0001 18.1251C10.2931 18.1243 10.5747 18.0014 10.7732 17.7865L12.0721 16.3803L13.9511 16.7538C14.2368 16.8116 14.5395 16.7457 14.7755 16.5732C15.0123 16.4014 15.1678 16.1361 15.2028 15.8448L15.4265 13.9429L17.1673 13.1414C17.4326 13.0185 17.6368 12.789 17.7272 12.5115C17.8175 12.234 17.7882 11.928 17.645 11.67L16.7075 10.0001ZM15.5633 10.5152L16.4503 12.0956L14.8064 12.8524C14.4752 13.003 14.2416 13.322 14.1977 13.6866L13.9861 15.4867L12.2096 15.1327C11.8499 15.0595 11.4747 15.1824 11.2298 15.4501L9.9997 16.7815L8.77208 15.4526C8.5727 15.2345 8.28787 15.1124 7.99612 15.1124C7.92776 15.1124 7.85941 15.1189 7.79145 15.1327L6.0137 15.4867L5.80171 13.6866C5.75898 13.3236 5.52664 13.0046 5.19665 12.8533L3.55073 12.0956L4.43818 10.5128C4.61681 10.1921 4.61681 9.80843 4.43736 9.48535L3.55073 7.90454L5.19421 7.1473C5.52624 6.99634 5.75898 6.67692 5.80171 6.31355L6.01371 4.51383L7.79064 4.86783C8.14993 4.93904 8.52346 4.81737 8.77046 4.55004L9.99971 3.21826L11.2298 4.55045C11.478 4.81819 11.8539 4.94107 12.2088 4.86783L13.9861 4.51383L14.1985 6.31518C14.2424 6.67895 14.476 6.99796 14.804 7.14607L16.4503 7.90454L15.5641 9.48454C15.3818 9.80721 15.3818 10.193 15.5633 10.5152Z" fill="currentColor"/>
                  <path d="M12.4749 7.89152L9.58345 10.783L8.35867 9.55818C8.11453 9.31404 7.71902 9.31404 7.47488 9.55818C7.23074 9.80232 7.23074 10.1978 7.47488 10.442L9.14155 12.1086C9.26362 12.2307 9.42354 12.2917 9.58345 12.2917C9.74336 12.2917 9.90327 12.2307 10.0253 12.1086L13.3587 8.7753C13.6028 8.53116 13.6028 8.13566 13.3587 7.89151C13.1145 7.64737 12.719 7.64738 12.4749 7.89152Z" fill="currentColor"/>
                </svg>
              </div>
            </div>
            <a href="${productUrl}" class="review-btn-container flex items-center gap-1 text-[var(--color-neutral-900)] hover:underline">
              <p class="review-btn text-sm font-bold underline">Read more</p>
              <svg class="w-5 h-5 text-[var(--color-neutral-900)]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 15" fill="none">
              <path d="M16.0669 6.84977L9.40022 0.183106C9.15608 -0.0610354 8.76057 -0.0610354 8.51643 0.183106C8.27229 0.427248 8.27229 0.822756 8.51643 1.0669L14.1162 6.66667H0.625C0.27995 6.66667 0 6.94661 0 7.29166C0 7.63671 0.27995 7.91666 0.625 7.91666H14.1162L8.51643 13.5164C8.27229 13.7606 8.27229 14.1561 8.51643 14.4002C8.63851 14.5223 8.79802 14.5833 8.95833 14.5833C9.11865 14.5833 9.27816 14.5223 9.40022 14.4002L16.0669 7.73356C16.18 7.62044 16.25 7.46419 16.25 7.29166C16.25 7.11914 16.18 6.96289 16.0669 6.84977Z" fill="currentColor"/>
              </svg>
            </a>
            <button onclick="window.openYotpoOverlay();" yotpo-overlay-trigger class="flex items-center gap-1 text-[var(--color-neutral-900)] hover:underline">
              <p class="review-btn text-sm font-bold underline">Read more</p>
              <svg class="w-5 h-5 text-[var(--color-neutral-900)]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 15" fill="none">
              <path d="M16.0669 6.84977L9.40022 0.183106C9.15608 -0.0610354 8.76057 -0.0610354 8.51643 0.183106C8.27229 0.427248 8.27229 0.822756 8.51643 1.0669L14.1162 6.66667H0.625C0.27995 6.66667 0 6.94661 0 7.29166C0 7.63671 0.27995 7.91666 0.625 7.91666H14.1162L8.51643 13.5164C8.27229 13.7606 8.27229 14.1561 8.51643 14.4002C8.63851 14.5223 8.79802 14.5833 8.95833 14.5833C9.11865 14.5833 9.27816 14.5223 9.40022 14.4002L16.0669 7.73356C16.18 7.62044 16.25 7.46419 16.25 7.29166C16.25 7.11914 16.18 6.96289 16.0669 6.84977Z" fill="currentColor"/>
              </svg>
            </button>
          </div>
        </li>`;
        }

        renderReviews(reviews) {
            const frag = document.createDocumentFragment();
            reviews.forEach(r => {
                frag.appendChild(document.createRange().createContextualFragment(this.renderReviewCard(r)));
            });
            this.reviewContainer.innerHTML = '';
            this.reviewContainer.appendChild(frag);

            this.dispatchEvent(new CustomEvent("suspense-ready", {
                bubbles: true
            }))
        }

        dispatchLoaded() {
            this.dispatchEvent(new CustomEvent('reviews:loaded', {
                bubbles: true,
                composed: true,
                detail: {carouselId: `#${this.id}`}
            }));
        }
    }

    customElements.define('yotpo-review-carousel', YotpoReviewCarousel);
}


document.addEventListener('reviews:loaded', async (e) => {
    const carouselElement = e.target;
    if (!carouselElement) return;

    const splideEl = carouselElement.querySelector('.splide');
    const list = carouselElement.querySelector('.splide__list');
    const track = carouselElement.querySelector('.splide__track');

    if (!splideEl || !list || !track) {
        console.log('Splide init failed');
        return;
    }

    await ResourceCoordinator.requestVendor("Splide");

    const isOverflowing = list.scrollWidth + 1 > track.clientWidth;

    const baseOptions = {
        type: 'slide',
        gap: '32px',
        padding: {right: '50px'},
        arrows: isOverflowing,
        pagination: isOverflowing,
        perPage: 5,
        perMove: 1,
        autoWidth: true,
        breakpoints: {
            1440: {
                perPage: 4,
                gap: '32px',
                padding: {right: '0px'},
            },
            1024: {
                perPage: 3,
                perMove: 1,
                gap: '8px',
                padding: {right: '0px'},
                arrows: true,
            },
            768: {
                perPage: 2,
                perMove: 1,
                arrows: false,
                pagination: true,
                padding: {right: '64px'},
            },
            480: {
                perPage: 1,
                perMove: 1,
                gap: '8px',
                padding: {right: '43px'},
                arrows: false,
                pagination: true,
            },
        }
    };


    const splide = new Splide(splideEl, baseOptions);
    splide.on('pagination:mounted', (data) => {
        const totalSlides = splide.length;
        const perPage = splide.options.perPage || 1;
        const perMove = splide.options.perMove || 1;

        const numDots = Math.max(1, Math.ceil((totalSlides - perPage) / perMove) + 1);
        data.list.innerHTML = '';

        for (let i = 0; i < numDots; i++) {
            const li = document.createElement('li');
            li.className = 'splide__pagination__page';
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.addEventListener('click', () => {
                splide.go(i * perMove);
            });
            li.appendChild(btn);
            data.list.appendChild(li);
        }

        const firstDot = data.list.querySelector('.splide__pagination__page');
        if (firstDot) firstDot.classList.add('is-active');
    });

    splide.on('move', (newIndex) => {
        const perMove = splide.options.perMove || 1;
        const paginationDots = splideEl.querySelectorAll('.splide__pagination__page');
        const activeDotIndex = Math.floor(newIndex / perMove);

        paginationDots.forEach((dot, index) => {
            dot.classList.toggle('is-active', index === activeDotIndex);
        });
    });

    splide.mount();
}, {once: true});

